<template>
  <div class="footer-social">
    <span class="footer-social__text">{{ $t('footer_social_title') }}</span>
    <ul class="footer-social__list">
      <li class="footer-social__item">
        <div class="footer-social__wrap footer-social__wrap--facebook">
          <a
            href="//www.facebook.com/polska.dniprom/"
            class="footer-social__link"
            target="_blank"
            rel="noreferrer">
            <svg
              width="8"
              height="16">
              <use :xlink:href="spritePath + '#facebook'"></use>
            </svg>
            <span class="visually-hidden">facebook</span>
          </a>
        </div>
      </li>
      <!--      <li class="footer-social__item">-->
      <!--        <div class="footer-social__wrap footer-social__wrap&#45;&#45;youtube">-->
      <!--          <a-->
      <!--            href="//www.youtube.com/channel/UC3eL5EiGjih2hId2TtM8E6g"-->
      <!--            class="footer-social__link"-->
      <!--            target="_blank"-->
      <!--            rel="noreferrer">-->
      <!--            <svg-->
      <!--              width="16"-->
      <!--              height="12">-->
      <!--              <use :xlink:href="spritePath + '#youtube'"></use>-->
      <!--            </svg>-->
      <!--            <span class="visually-hidden">youtube</span>-->
      <!--          </a>-->
      <!--        </div>-->
      <!--      </li>-->
      <li class="footer-social__item">
        <div class="footer-social__wrap footer-social__wrap--instagram">
          <a
            href="//instagram.com/dniprom.pl?igshid=MzRlODBiNWFlZA=="
            class="footer-social__link"
            target="_blank"
            rel="noreferrer">
            <svg
              width="16"
              height="16">
              <use :xlink:href="spritePath + '#instagram'"></use>
            </svg>
            <span class="visually-hidden">instagram</span>
          </a>
        </div>
      </li>
      <li class="footer-social__item">
        <div class="footer-social__wrap footer-social__wrap--viber">
          <a
            href="https://www.tiktok.com/@dniprom.pl_official?_r=1"
            class="footer-social__link"
            target="_blank"
            rel="noreferrer">
            <svg
              width="16"
              height="16">
              <use :xlink:href="spritePath + '#tiktok'"></use>
            </svg>
            <span class="visually-hidden">TikTok</span>
          </a>
        </div>
      </li>
      <li class="footer-social__item">
        <div class="footer-social__wrap footer-social__wrap--allegro">
          <a
            :href="$t('link.to.allegro')"
            class="footer-social__link"
            target="_blank"
            @click="handleAllegroRedirect($event, $t('link.to.allegro'))"
            rel="noreferrer">
            <svg
              width="11"
              height="13">
              <use :xlink:href="spritePath + '#allegro'"></use>
            </svg>
            <span class="visually-hidden">Allegro</span>
          </a>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { spritePath } from '@/mixins/spritePath'
import { GoogleEnhancedEcommerce } from '@/services/AnalyticService'

export default {
  name: 'FooterSocial',
  mixins: [spritePath],
  computed: {
    ...mapState({
      language: state => state.translation.language
    })
  },
  methods: {
    async handleAllegroRedirect (e, link) {
      e.preventDefault()
      if (GoogleEnhancedEcommerce.isEnabled) {
        await GoogleEnhancedEcommerce.clickFooterAllegro()
      }
      window.open(link, '_blank', 'noopener, noreferrer')
    }
  }
}
</script>

<style scoped lang="sass">

.footer-social
  width: 25%

  +mmax(768)
    width: 100%

.footer-social__list
  width: 100%
  max-width: 230px
  display: flex
  align-items: center
  list-style: none
  justify-content: flex-start
  padding: 0
  margin: 0

.footer-social__wrap
  position: relative
  width: 30px
  height: 30px
  background-color: #f5f5f5
  border-radius: 50%
  transition: .4s

.footer-social__wrap svg
  position: absolute
  top: 50%
  left: 50%
  transform: translate(-50%, -50%)
  fill: #fff
  transition: .2s

.footer-social__link
  display: block
  width: 100%
  height: 100%

.footer-social__text
  display: none
  font-weight: 400
  font-size: 14px
  line-height: 17px
  color: #909090
  margin-bottom: 20px

  +mmax(768)
    display: block

.footer-social__item
  margin-right: 5px

  &:hover
    .footer-social__wrap
      background-color: rgba(255, 255, 255, 0.2)
    //.footer-social__wrap--facebook
    //  background-color: darken(#4267B2, 10%)
    //
    //.footer-social__wrap--youtube
    //  background-color: darken(#FF0000, 10%)
    //
    //.footer-social__wrap--instagram
    //  background-color: darken(#BF2F97, 10%)
    //
    //.footer-social__wrap--telegram
    //  background-color: darken(#0088CC, 10%)
    //
    //.footer-social__wrap--viber
    //  background-color: darken(#665CAC, 10%)

.footer-social__item
  .footer-social__wrap svg
    fill: #fff

  .footer-social__wrap
    background-color: rgba(255, 255, 255, 0.1)

  //.footer-social__wrap--facebook
  //  background-color: #4267B2
  //
  //.footer-social__wrap--youtube
  //  background-color: #FF0000
  //
  //.footer-social__wrap--instagram
  //  background-color: #BF2F97
  //
  //.footer-social__wrap--telegram
  //  background-color: #0088CC
  //
  //.footer-social__wrap--viber
  //  background-color: #665CAC

</style>
